import React from 'react';
import * as style from '../../../styles/markdown.module.scss';

export const MarkdownImage = ({ children, src, alt, ...props }) => (
  <section className={style.mrkdImageBox}>
    <img className={style.mrkdImage} src={src} alt={alt} />
  </section>
);
